import {isArray, isObject} from 'lodash';
import {DlSelectSelectedMultiValue, DlSelectSelectedValue} from 'src/js/common/types';

export function isMultiValue(value: DlSelectSelectedValue | undefined, isMulti: boolean): value is DlSelectSelectedMultiValue {
  return isMulti && isArray(value);
}

export function getValue<Option = unknown>(
  value: DlSelectSelectedValue | undefined,
  options: readonly Option[] | undefined,
  isMulti: boolean,
  valueProperty: string
) {
  let currentValue;
  if (options && options.length) {
    if (isMultiValue(value, isMulti)) {
      const currentValues = value ? value.map((valueItem) => (isObject(valueItem) ? valueItem[valueProperty] : valueItem)) : null;
      currentValue = currentValues ? options.filter((option) => currentValues.includes(option[valueProperty])) : null;
    } else {
      currentValue = options.filter((option) => option[valueProperty] === (isObject(value) ? value[valueProperty] : value));
    }
  } else {
    // empty options, just show value as it is
    currentValue = value;
  }
  return currentValue;
}

export function isOptionEqualToValue<T = unknown>(option: T, value: T | null, valueProperty: string): boolean {
  // NOTE: we coerce to same type, since we want ('-1093' == -1093) to return true
  // NOTE: return false if either `option[valueProperty]` or `value[valueProperty]` is nullsy
  /* eslint-disable eqeqeq */
  const firstTest = option == value;
  const secondTest = option[valueProperty] && option[valueProperty] == value;
  const thirdTest = option[valueProperty] && option[valueProperty] == value?.[valueProperty];
  return firstTest || secondTest || thirdTest;
  /* eslint-enable eqeqeq */
}

/* Return value clamped between min and max, returning min if min > max */
export function clampMin(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(value, max));
}
